import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fl-row-b benefitActionModal__info" }
const _hoisted_2 = { class: "benefitActionModal__detail" }
const _hoisted_3 = { class: "benefitActionModal__detail__user" }
const _hoisted_4 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "姓名：", -1)
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "工号：", -1)
const _hoisted_9 = { class: "right" }
const _hoisted_10 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "手机号：", -1)
const _hoisted_12 = { class: "right" }
const _hoisted_13 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "部门：", -1)
const _hoisted_15 = { class: "right" }
const _hoisted_16 = { class: "benefitActionModal__detail__user-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "left" }, "公司：", -1)
const _hoisted_18 = { class: "right" }
const _hoisted_19 = { class: "detailTable" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("caption", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "总里程:", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "总时长:", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, "油补金额:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "补贴周期:", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, "当月上限:", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "剩余额度:", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, "车辆名称:", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, "车牌号码:", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, "车类型:", -1)
const _hoisted_31 = { colspan: "3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, "提交日期:", -1)
const _hoisted_33 = { colspan: "3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "benefitActionModal__map" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "轨迹地图"),
  /*#__PURE__*/_createElementVNode("div", { id: "mapContainer" })
], -1)
const _hoisted_35 = { class: "benefitActionModal__info__available" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "可发放补贴：", -1)
const _hoisted_37 = { class: "tip" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "系统", -1)
const _hoisted_40 = {
  key: 2,
  class: "separator"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "备注", -1)
const _hoisted_42 = {
  key: 4,
  class: "separator"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { style: {"color":"red"} }
const _hoisted_45 = {
  key: 0,
  class: "benefitActionModal__addition__info"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h2", null, "附加信息：", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("caption", null, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", null, "用车原因:", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", null, "出发地是否为家:", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", null, "目的地是否为家:", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", null, "费用承担部门:", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", null, "过路费:", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, "停车费:", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", null, "跨城用车:", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", null, "公共交通金额:", -1)
const _hoisted_57 = {
  key: 1,
  class: "benefitActionModal__addition__info"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h2", null, "通用附加信息：", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("caption", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", null, "申报实际行驶里程:", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("td", null, "举证照片:", -1)
const _hoisted_63 = { key: 1 }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", null, "油补金额:", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", null, "可发放金额:", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f00a0c","margin-left":"20px"} }, "*审核通过后将按此金额发放补贴", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h2", null, "审核：", -1)
const _hoisted_68 = { style: {"margin-bottom":"20px"} }
const _hoisted_69 = {
  key: 0,
  class: "fl-column"
}
const _hoisted_70 = {
  key: 1,
  class: ""
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", null, "备注：", -1)
const _hoisted_72 = {
  key: 1,
  class: "benefitActionModal__audit"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", null, "审批人：", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ImageViewer = _resolveComponent("ImageViewer")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visible) = $event)),
    class: "benefitActionModal",
    width: "940px",
    onCancel: _ctx.onCancel
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", null, "行程单号：" + _toDisplayString(_ctx.record.businessNo), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.action === 'view' ? '返回': '取消'), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.action !== 'view')
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: "submit",
            type: "primary",
            loading: _ctx.submiting,
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.record.userName || '---'), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.record.userJobNumber || '---'), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.record.userPhone ? `${_ctx.record.userPhone.substr(0,3)}****${_ctx.record.userPhone.substr(7)}` : '---'), 1)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.record.departmentsStr || '---'), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.record.enterpriseName || '---'), 1)
            ])
          ]),
          _createElementVNode("table", _hoisted_19, [
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("tr", null, [
              _hoisted_22,
              _createElementVNode("td", null, _toDisplayString(_ctx.record.totalDistanceKm || '---') + "公里", 1),
              _hoisted_23,
              _createElementVNode("td", null, _toDisplayString(_ctx.record.totalTimeHh || '---'), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_24,
              _createElementVNode("td", null, "￥" + _toDisplayString(_ctx.formatWithIntl(_ctx.toLocalUnit(+(_ctx.record.supplementAmount || 0)))), 1),
              _hoisted_25,
              _createElementVNode("td", null, _toDisplayString(_ctx.record.subsidiesCycle), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_26,
              _createElementVNode("td", null, "￥" + _toDisplayString(_ctx.formatWithIntl(_ctx.toLocalUnit(+( _ctx.record.supplementLimitAmount|| 0)))), 1),
              _hoisted_27,
              _createElementVNode("td", null, "￥" + _toDisplayString(_ctx.record.leftAmount || 0), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_28,
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.record.vehicleName || '---'), 1)
              ]),
              _hoisted_29,
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.record.licensePlate || '---'), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_30,
              _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.record.vehicleType === 0 ? '公车' : _ctx.record.vehicleType === 1 ? '私车' : '---'), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_32,
              _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.formatDate(_ctx.record.createTime)), 1)
            ])
          ])
        ]),
        _hoisted_34
      ]),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formatWithIntl(_ctx.toLocalUnit(+(_ctx.record.availableAmount|| 0)))) + "元", 1)
      ]),
      _createVNode(_component_a_table, {
        columns: _ctx.tableColumns,
        "row-key": "id",
        "data-source": _ctx.record.passPoints,
        pagination: false
      }, {
        action: _withCtx(({ record }) => [
          (!record.imgUrl && !record.remark && !record.pointErrInfo.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_38, "---"))
            : _createCommentVNode("", true),
          (record.pointErrInfo.length)
            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 1,
                placement: "top"
              }, {
                title: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.pointErrInfo, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ]),
                default: _withCtx(() => [
                  _hoisted_39
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (record.remark && record.pointErrInfo.length)
            ? (_openBlock(), _createElementBlock("i", _hoisted_40))
            : _createCommentVNode("", true),
          (record.remark)
            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 3,
                placement: "top"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(record.remark), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_41
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (record.imgUrl && record.remark)
            ? (_openBlock(), _createElementBlock("i", _hoisted_42))
            : _createCommentVNode("", true),
          (record.imgUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 5,
                href: "#",
                onClick: ($event: any) => (_ctx.$vp(record.imgUrl))
              }, "附件", 8, _hoisted_43))
            : _createCommentVNode("", true)
        ]),
        tag: _withCtx(({ record }) => [
          _createElementVNode("div", null, _toDisplayString(record.flag ? `${record.tag || '---'}(补充)` : record.tag), 1),
          _createElementVNode("div", _hoisted_44, _toDisplayString(record.tagException), 1)
        ]),
        _: 1
      }, 8, ["columns", "data-source"]),
      (_ctx.expensesSubsidizedFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("table", null, [
              _hoisted_47,
              _hoisted_48,
              _createElementVNode("tr", null, [
                _hoisted_49,
                _createElementVNode("td", null, _toDisplayString(_ctx.expensesSubsidized.reasons || '---'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_50,
                _createElementVNode("td", null, _toDisplayString(_ctx.expensesSubsidized.departureIsHome ? '是' : '否'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_51,
                _createElementVNode("td", null, _toDisplayString(_ctx.expensesSubsidized.destinationIsHome ? '是' : '否'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_52,
                _createElementVNode("td", null, _toDisplayString(_ctx.expensesSubsidized.bearingDepartmentName || '---'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_53,
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.expensesSubsidized.hasTollFee ? `￥${ _ctx.expensesSubsidized.tollFee || 0 }` : '无'), 1),
                  (_ctx.expensesSubsidized.tollInvoiceInfo && _ctx.expensesSubsidized.tollInvoiceInfo.length)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "img__url",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkVoucher('tollFee', _ctx.expensesSubsidized.tollInvoiceInfo)))
                      }, "查看发票"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_54,
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.expensesSubsidized.hasParkingFee ? `￥${_ctx.expensesSubsidized.parkingFee || 0 }` : '无'), 1),
                  (_ctx.expensesSubsidized.parkingFeeVoucher && _ctx.expensesSubsidized.parkingFeeVoucher.length)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "img__url",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkVoucher('parkingFee', _ctx.expensesSubsidized.parkingFeeVoucher)))
                      }, "停车费凭证"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_55,
                _createElementVNode("td", null, _toDisplayString(_ctx.expensesSubsidized.hasCrossCity ? '是' : '否'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_56,
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, "￥" + _toDisplayString(_ctx.expensesSubsidized.publicTransportationFee || 0), 1),
                  (_ctx.expensesSubsidized.crossCityVoucher && _ctx.expensesSubsidized.crossCityVoucher.length)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "img__url",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkVoucher('crossCityVoucher', _ctx.expensesSubsidized.crossCityVoucher)))
                      }, "查看"))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.record.declaredMile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("table", null, [
              _hoisted_59,
              _hoisted_60,
              _createElementVNode("tr", null, [
                _hoisted_61,
                _createElementVNode("td", null, _toDisplayString(_ctx.record.proofDistanceKm || '---') + "公里", 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_62,
                _createElementVNode("td", null, [
                  (_ctx.record.realDistanceProofImage && _ctx.record.realDistanceProofImage.length)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkVoucher('realDistanceProofImage', _ctx.record.realDistanceProofImage)))
                      }, [
                        _createVNode(_component_a_badge, {
                          count: _ctx.record.realDistanceProofImage.length
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              size: "small",
                              shape: "round"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("查看")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["count"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_63, "无"))
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_64,
                _createElementVNode("td", null, _toDisplayString(_ctx.record.supplementAmountY || '---') + "元", 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_65,
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.record.availableAmountY || '---'), 1),
                  _hoisted_66
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _hoisted_67,
        (_ctx.action === 'approve')
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              class: "benefitActionModal__audit"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_68, [
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.formData.approveStatus,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.approveStatus) = $event)),
                    options: [{ label: '同意', value: 1 }, { label: '驳回', value: 2 }],
                    style: {"width":"160px","padding":"5px 0"}
                  }, null, 8, ["value"]),
                  (_ctx.formData.approveStatus === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.formData.canResubmit,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.canResubmit) = $event)),
                          options: [{ label: '允许重复提交', value: true }, { label: '不允许重复提交', value: false }],
                          style: {"padding":"5px 0"}
                        }, null, 8, ["value"]),
                        _createVNode(_component_a_input, {
                          value: _ctx.formData.reason,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.reason) = $event)),
                          placeholder: "驳回原因",
                          style: {"width":"200px"},
                          maxlength: 20
                        }, null, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.approveStatus === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        _hoisted_71,
                        _createVNode(_component_a_input, {
                          value: _ctx.formData.reason,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.reason) = $event)),
                          placeholder: "备注",
                          style: {"width":"350px"},
                          maxlength: 20
                        }, null, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_72, [
              _createElementVNode("div", null, "初审：" + _toDisplayString(_ctx.record.approveStatus ? _ctx.record.approveStatus === 1 ? "审核通过" : `审核驳回${_ctx.record.canResubmit ? '(允许重复提交)' : '(不允许重复提交)'}` : '---'), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.record.approveStatus === 2 ? '驳回原因：': '备注：') + _toDisplayString(_ctx.record.reason || '---'), 1),
              _createElementVNode("div", null, [
                _hoisted_73,
                _createElementVNode("span", null, _toDisplayString(_ctx.record.approveUser || '---') + _toDisplayString(_ctx.record.approveJobNumber ? `(${_ctx.record.approveJobNumber})` : ''), 1)
              ]),
              _createElementVNode("div", null, "审批时间：" + _toDisplayString(_ctx.formatDate(_ctx.record.approveTime)), 1)
            ]))
      ]),
      _createVNode(_component_ImageViewer, {
        visible: _ctx.picVisible,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.picVisible) = $event)),
        "preview-src-list": _ctx.imageList
      }, null, 8, ["visible", "preview-src-list"])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}